import React from "react";
import { Alert, AlertDescription, AlertIcon, AlertTitle, Button, Flex } from "@chakra-ui/react";

const ErrorState = ({ title, description, onRetry }) => {
  return (
    <Alert status="error" variant="subtle" borderRadius="md">
      <AlertIcon />
      <Flex direction="column" gap={2} flex="1">
        <AlertTitle>{title}</AlertTitle>
        <AlertDescription>{description}</AlertDescription>
        <Button size="sm" alignSelf="flex-start" onClick={onRetry}>
          Retry
        </Button>
      </Flex>
    </Alert>
  );
};

export default ErrorState;
